<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.bet_list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton.mr-1(:loading="loading" icon="fa fa-arrow-left" :text="$t('ui.back')" isModal=false type="button" @click="back")
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="timer + ' ' + $t('ui.seconds')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-12.col-lg-6.col-xl-6
                b-table#tblList.table-sm.table-hover.table-bordered(caption-top striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="getBetListHome" :fields="fields" :filter="filter")
                  template(v-slot:table-caption)
                    div.text-center.align-middle  #[b {{ getHomeTeamName }}]
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(bet_time)="row")
                    template(v-if="$store.getters.getBetListDetail.is_live == 1")
                      span.mr-1.badge.badge-green.blink_me {{ $t("ui.live") }}
                      span {{ $store.getters.getBetListDetail.home_running_score + " - " + $store.getters.getBetListDetail.away_running_score }}
                    template(v-else)
                      span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                      br
                      span #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(event)="row")
                    div
                      span #[b {{ getName(row.item.league_id, 0) }}]
                    div(v-if="row.item.home_team_name != null")
                      span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                      span.mr-1 vs
                      span.mr-1(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                    div
                      span(v-if="isLiveMarket(row.item)") ({{ row.item.home_running_score}} - {{ row.item.away_running_score }})
                  template(v-slot:cell(detail)="row")
                    div.mb-1
                      span.label.bg-black #[b {{ getBetType(row.item) }}]
                    div
                      span(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item) }}
                    div
                      span {{ row.item.agent_pt }} x {{ row.item.bet_member }}
                      br
                      span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                      span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                  template(v-slot:cell(bet_amount)="row")
                    span(:class="$helpers.getNumberClass(getBetAmount(row.item))") #[b {{ getBetAmount(row.item) | currency }} ]
                  template(v-slot:bottom-row="row" v-if="(getBetListHome) ? getBetListHome.length > 0 : false")
                    td.text-right(colspan="4")
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(grandTotalBetAmountHome)")  #[b {{ grandTotalBetAmountHome | currency }} ]
              .col-sm-12.col-md-12.col-lg-6.col-xl-6
                b-table#tblList.table-sm.table-hover.table-bordered(caption-top striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="getBetListAway" :fields="fields" :filter="filter")
                  template(v-slot:table-caption)
                    div.text-center.align-middle #[b {{ getAwayTeamName }}]
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(bet_time)="row")
                    template(v-if="getBetListDetail.is_live == 1")
                      span.mr-1.badge.badge-green.blink_me {{ $t("ui.live") }}
                      span {{ getBetListDetail.home_running_score + " - " + getBetListDetail.away_running_score }}
                    template(v-else)
                      span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(event)="row")
                    div
                      span #[b {{ getName(row.item.league_id, 0) }}]
                    div(v-if="row.item.home_team_name != null")
                      span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                      span.mr-1 vs
                      span.mr-1(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                    div
                      span(v-if="isLiveMarket(row.item)") ({{ row.item.home_running_score}} - {{ row.item.away_running_score }})
                  template(v-slot:cell(detail)="row")
                    div.mb-1
                      span.label.bg-black #[b {{ getBetType(row.item) }}]
                    div
                      span(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item) }}
                    div
                      span {{ row.item.agent_pt }} x {{ row.item.bet_member }}
                      br
                      span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                      span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                  template(v-slot:cell(bet_amount)="row")
                    span(:class="$helpers.getNumberClass(getBetAmount(row.item))") #[b {{ getBetAmount(row.item) | currency }} ]
                  template(v-slot:bottom-row="row" v-if="(getBetListAway) ? getBetListAway.length > 0 : false")
                    td.text-right(colspan="4")
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(grandTotalBetAmountAway)")  #[b {{ grandTotalBetAmountAway | currency }} ]
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      filter: null,
      pulling: null,
      countdown: null,
      timer: 60,
      showTotalHome: false,
      showTotalAway: false,
      match: [],
      league: []
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "bet_time",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_amount",
          label: this.$t("ui.amount"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    getBetListDetail() {
      return this.$store.getters.getBetListDetail
    },
    getBetListHome() {
      if(this.betList.length > 0) {
        return this.betList.filter((value, index, self) => value.home_away == 1)
      }
    },
    getBetListAway() {
      if(this.betList.length > 0) {
        return this.betList.filter((value, index, self) => value.home_away == 2)
      }
    },
    getHomeTeamName() {
      if(this.betList.length > 0) {
        let name = ""
        this.match.forEach(y => {
          name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
        })
        return name
      }
    },
    getAwayTeamName() {
      if(this.betList.length > 0) {
        let name = ""
        this.match.forEach(y => {
          name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
        })
        return name
      }
    },
    grandTotalBetAmountHome() {
      let sum = 0
      if(this.getBetListHome.length > 0) {
        if(this.getBetListDetail.full_amount == 1) {
          this.getBetListHome.forEach(value => {
            sum += value.bet_member
          })
        } else {
          this.getBetListHome.forEach(value => {
            sum += value.bet_agent
          })
        }
      }
      return sum
    },
    grandTotalBetAmountAway() {
      let sum = 0
      if(this.getBetListAway.length > 0) {
        if(this.getBetListDetail.full_amount == 1) {
          this.getBetListAway.forEach(value => {
            sum += value.bet_member
          })
        } else {
          this.getBetListAway.forEach(value => {
            sum += value.bet_agent
          })
        }
      }
      return sum
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    if(this.getBetListDetail) {
      this.search()
      this.countdown = setInterval(() => {
        this.timer -= 1
      }, 1 * 1000)
      this.pulling = setInterval(() => {
        this.search()
        this.timer = 60
      }, 1 * 61000)
    } else {
      this.$router.push("/betList")
    }
  },
  beforeDestroy: function() {
    clearInterval(this.pulling)
    clearInterval(this.countdown)
  },
  methods: {
    getBetType(item) {
      let type = item.bet_type
      let share = item.bet_type_share

      if(type == 'HDP' && share == 'HDPMMO') {
        return this.$tc("m.BT_HDPMMO")
      }

      if(type == 'OU' && share == 'HDPMMO') {
        return this.$tc("m.BT_OUMMO")
      }

      return this.$tc("m.BT_" + type, 2)
    },
    back: function(){
      this.$router.push("/betListHDPOU")
    },
    isLiveMarket: function(item) {
      return item.market_type == 3 && (item.bet_type == 'HDP' || item.bet_type == 'HDPH' || item.bet_type == 'OU' || item.bet_type =='OUH')
    },
    getBetAmount: function(item) {
      if(this.getBetListDetail.full_amount == 1) {
        return item.bet_member
      } else {
        return item.bet_agent
      }
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    search: function() {
      let bet_type = this.getBetListDetail.bet_type
      let match_id = this.getBetListDetail.match_id
      let is_live = this.getBetListDetail.is_live
      let home_running_score = this.getBetListDetail.home_running_score
      let away_running_score = this.getBetListDetail.away_running_score
      this.loading = true
      this.$store
        .dispatch("user/getActiveBetlistHDP", { bet_type, match_id, is_live, home_running_score, away_running_score })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.betList = response.data
              this.match = response.names.match
              this.league = response.names.league
            } else {
              this.betList = []
              this.match = []
              this.league = []
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          this.betList = []
          this.match = []
          this.league = []
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    }
  }
};
</script>